// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"5597f5c4","549":"525a6e25"}[chunkId] + ".chunk.js";
};